module.exports = __webpack_public_path__ + "img/xxx-coder.85c557b3.webp";